import React, { useState } from "react";
import { IoIosClose } from "react-icons/io";
import LineLogo from "../../../assets/LineLogo.png";

function DeactivateEmployee({ onConfirm, onCancel }) {
  const [loading, setLoading] = useState(false);
  return (
    <div
      style={{
        position: "fixed",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
        height: "100vh",
        width: "100%",
        background: " rgba(0, 0, 0, 0.5)",
        zIndex: "1218",
      }}
    >
      <div className=" relative mx-auto sm:px-10 top-10 mt-10 md:container md:mx-auto font-OpenSans justify-between items-center">
        <div
          style={{
            width: window.innerWidth > 600 ? "500px" : window.innerWidth - 20,
            height: window.innerHeight > 700 ? "650px" : "580px",

            position: "fixed",
            background: "white",
            left: "0",
            top: "0",
            bottom: "0",
            right: "0",
            margin: "auto",
            borderRadius: "10px",
          }}
          className="shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] p-2"
        >
          <IoIosClose
            className="float-right cursor-pointer"
            size={25}
            onClick={onCancel}
          />
          <div style={{ marginLeft: "35px" }}>
            <div>
              <h1 className="text-lg sm:text-2xl font-semibold mb-3 pt-1">
                Deactivate Employee
              </h1>
            </div>
            <div>
              <p className="text-sm text-[#5F5F5F] float-left font-medium  mb-3 mt-3md:ml-2">
                Please upload the following documents
              </p>
            </div>
            <div className="mb-5">
              <img src={LineLogo} alt="" />
            </div>
            <div className=" mb-2 sm:mb-5">
              <label className="text-[#5F5F5F] text-md mb-1">
                Relieving Letter (Optional)
              </label>
              <div className="bg-[#EDF2FF] cursor-pointer h-20 w-11/12 rounded-lg border-dashed border-2 mt-1  border-[#B4C9FF] flex justify-center items-center hover:cursor-pointer">
                <div className="absolute">
                  <div className="flex items-center">
                    <p className="block text-[#2F5FDA] font-bold p-[4px] ">
                      Click to upload
                    </p>
                    <p className="block text-[#666666]">
                      or drag and drop <br />
                    </p>
                  </div>
                  <p className="block text-sm text-slate-500 text-center ">
                    PDF file
                  </p>
                </div>
                <input type="file" class="h-full w-full opacity-0" name="" />
              </div>
            </div>
            <div className="mt-10 mb-2 sm:mb-5">
              <label className=" block text-[#5F5F5F] text-md ">
                Experience letter (Optional)
              </label>
              <div className="bg-[#EDF2FF] cursor-pointer h-20 w-11/12 rounded-lg border-dashed border-2 mt-1  border-[#B4C9FF] flex justify-center items-center hover:cursor-pointer">
                <div className="absolute">
                  <div className="flex items-center">
                    <p className="block text-[#2F5FDA] font-bold p-[4px] ">
                      Click to upload
                    </p>
                    <p className="block text-[#666666]">
                      or drag and drop <br />
                    </p>
                  </div>
                  <p className="block text-sm text-slate-500 text-center ">
                    PDF/PNG file
                  </p>
                </div>
                <input type="file" class="h-full w-full opacity-0" name="" />
              </div>
            </div>
          </div>
          <div>
            <button
              className="w-11/12 h-12 mt-3  bottom-10 absolute self-center border mx-2 rounded-lg bg-[#3C69DF] hover:bg-[#284ba3] text-white text-bold"
              onClick={() => {
                setLoading(true);
                onConfirm();
              }}
            >
              {loading ? (
                <svg
                  class="inline mr-2 w-8 h-8  animate-spin text-white fill-blue-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              ) : (
                "  Confirm"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeactivateEmployee;
